export default "__VITE_ASSET__B_dXMz4z__"